import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Studio from "@/pages/Studio";
import Login from "@/pages/Login";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Studio />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <AppRoutes />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#121212",
              border: "1px solid #1F1F1F",
              color: "#fff",
              fontFamily: "IBM Plex Sans, sans-serif",
              borderRadius: "2px",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
